<template>
  <field
    :empty="!forceLabelToTop"
    v-bind="$attrs"
    :label="label"
    :hide-label="hideLabel"
    class="text-left"
  >
    <div class="pt-14">
      <Slider
        v-model="value"
        v-bind="{ ...$attrs }"
        :format="{ suffix: '%' }"
        class="mx-3"
      />
      <slot/>
    </div>
  </field>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import Slider from '@vueform/slider';
import Field from '@components/utils/inputs/Field.vue';

interface Props {
  modelValue: number;
  label?: string;
  forceLabelToTop?: boolean;
  hideLabel?: boolean;
}

const emit = defineEmits(['update:modelValue']);
const props = defineProps<Props>();
const value = useVModel(props, 'modelValue', emit, { passive: true });

</script>
<style src="@vueform/slider/themes/default.css">
</style>
